import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { ValidatorMessageModel } from '../../form-helpers/validation/validator-message.model';
import { PopoverModel } from 'src/app/components/info-popover/popover.model';
import { ExpandableInfoModel } from '../../expandable-info.model';

@Component({
  selector: 'app-input-container',
  templateUrl: './input-container.component.html',
  styleUrls: ['./input-container.scss'],
})
export class InputContainerComponent implements OnInit {
  private static nextExpandableInfoGroupId = 0;

  @Input() label?: string;
  @Input() for?: string;
  @Input() validationMessages?: ValidatorMessageModel[];
  @Input() biggerFont?: boolean;
  @Input() isRequired = false;
  @Input() popoverInfo?: PopoverModel;
  @Input() expandableInfo?: ExpandableInfoModel[];

  @ViewChild('inputContainer') inputContainer?: ElementRef;
  hasValue = false;
  readonly expandableInfoGroupId = `expandable-input-info-${
    InputContainerComponent.nextExpandableInfoGroupId++
  }`;
  private expandedInfoIndexes = new Set<number>();

  ngOnInit(): void {}

  public get isInvalid(): boolean {
    return this.validationMessages?.length! > 0;
  }

  public get isValid(): boolean {
    return !this.validationMessages || this.validationMessages.length === 0;
  }

  expandableInfoId(index: number): string {
    return `${this.expandableInfoGroupId}-${index}`;
  }

  isExpandableInfoExpanded(index: number): boolean {
    return this.expandedInfoIndexes.has(index);
  }

  toggleExpandableInfo(index: number): void {
    if (this.expandedInfoIndexes.has(index)) {
      this.expandedInfoIndexes.delete(index);
    } else {
      this.expandedInfoIndexes.add(index);
    }
  }
}
